import { ColDef } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';

const cellStyleCentered = {
    display: 'flex',
    alignItems: 'center',
};

const defaultColDefParams = {
    sortable: true,
};

export const useGetColumnDefs = (): ColDef[] => {
    const { t } = useTranslation();
    return [
        {
            field: 'id',
            headerName: t('support.clientConfiguration.apiKey.id'),
            ...defaultColDefParams,
        },
        {
            field: 'isValid',
            headerName: t('support.clientConfiguration.apiKey.isValid'),
            ...defaultColDefParams,
            cellRenderer: 'booleanCellRenderer',
            cellStyle: cellStyleCentered,
        },
        {
            field: 'expirationDate',
            headerName: t('support.clientConfiguration.apiKey.expirationDate'),
            ...defaultColDefParams,
        },
    ];
};
